module.exports = __webpack_public_path__ + "img/1523413229.f1a8e074.jpg";